// @ts-nocheck


import React from 'react';


import { okeiApi } from '../../lib/api';

import AutocompleteSelect from './AutocompleteSelect';


export default (selectProps) =>
<AutocompleteSelect
  placeholder="Выберите ОКЕИ"
  fetch={okeiApi.fetch}
  fetchSingle={okeiApi.get}
  notFoundText="ОКЕИ не найдены"
  renderOption={(okei, Option) =>
  <Option value={okei.id} key={okei.id} okei={okei}>
        {okei.name}
      </Option>
  }
  {...selectProps} />;
